import type { Order, OrderCleanItem } from '@/types/order';
import {
  calcCleanItemDurationSubtotal,
  formatCleanItemWorkHours,
} from '@/api/modules/order';

interface OrderCleanItemsSectionProps {
  order: Pick<Order, 'cleanItems'>;
  /** 团队管理员可见每项工时；工作人员默认隐藏 */
  showDuration?: boolean;
}

function CleanItemRow({
  item,
  showDuration,
}: {
  item: OrderCleanItem;
  showDuration: boolean;
}) {
  const durationSubtotal = calcCleanItemDurationSubtotal(item);
  const durationLabel =
    showDuration && durationSubtotal > 0
      ? formatCleanItemWorkHours(item.duration, item.quantity)
      : null;

  return (
    <div className="flex items-center justify-between gap-3 text-[11px] leading-relaxed">
      <span className="font-medium text-gray-700 min-w-0 flex-1 truncate">{item.itemName}</span>
      <span className="text-gray-500 flex-shrink-0 whitespace-nowrap text-right tabular-nums">
        ×{item.quantity ?? 1}
        {durationLabel ? ` · ${durationLabel}` : ''}
      </span>
    </div>
  );
}

export function OrderCleanItemsSection({
  order,
  showDuration = true,
}: OrderCleanItemsSectionProps) {
  const items = order.cleanItems ?? [];
  if (items.length === 0) return null;

  return (
    <div>
      <div className="text-[10px] text-gray-400 font-medium uppercase tracking-wider mb-1.5 flex items-center gap-1.5">
        <i className="ri-list-check-2 text-green-500 text-xs" />
        Clean Items
      </div>
      <div className="space-y-1">
        {items.map((item) => (
          <CleanItemRow key={item.id} item={item} showDuration={showDuration} />
        ))}
      </div>
    </div>
  );
}
